import { buildCsrfToken, decrypt, encryptedParamsDynamic, testData, url } from "../decrypt";
const controller = new AbortController();
const signal = controller.signal;

async function reportGet(payloaddyna) {
    try {
        let payload = payloaddyna; // dynamic payload
        let encryptedParamsFromUrlPayload = encryptedParamsDynamic(payload);
        let csrfTokenFromUrlPayload = buildCsrfToken(encryptedParamsFromUrlPayload);

        const fetchDataPromise = fetch(`${url}/${testData[6].api}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                csrfToken: csrfTokenFromUrlPayload,
                rid: 1,
            },
            // body: JSON.stringify({ params: encryptedParams }), // static encryption
            body: JSON.stringify({
                params: encryptedParamsFromUrlPayload,
            }), // dynamic encryption
            signal,
        });

        const timeoutId = setTimeout(() => {
            controller.abort();
        }, 20000);

        const fetchData = await fetchDataPromise;

        let response = null;
        if (fetchData.ok) {
            clearTimeout(timeoutId);
            response = await fetchData.json();
        } else {
            response = [{ status: "FAILED" }];
        }
        return response;
    } catch (error) {
        if (error.name === "AbortError") {
            console.log("aborted", error.name);
            return [{ status: "TIMEOUT REACHED" }];
        } else {
            console.log("error", error);
        }
    }
}

async function decryptReportGetResponse(payload) {
    const toDecrypt = await reportGet(payload);
    let response = null;
    if (toDecrypt["status"] === "SUCCESS") {
        const successresponse = [{ status: toDecrypt["status"] }, JSON.parse(decrypt(toDecrypt["response"]))];
        // response = JSON.parse(decrypt(toDecrypt["response"]));
        response = successresponse;
    } else {
        response = toDecrypt;
    }
    return response;
}

export { decryptReportGetResponse };
